export default "__VITE_ASSET__be331116__"